export default __webpack_public_path__ + "static/media/sy.0cdb07cb.svg";